import { mobileAndTabletCheck } from '../helps';
function BlockULottie() {
    const animations = {

    }
    function init() {
        jQuery(window).on('load', () => {
            initLoad();
            jQuery(window).on("scroll", validateIfAnimation);
            validateIfAnimation();
        })

    }
    function initLoad() {
        const list = jQuery('.block-u-lottie__element');
        for (const iterator of list) {
            const element = jQuery(iterator);
            const file = element.data('file');
            const filemobile = element.data('filemobile');
            const path = mobileAndTabletCheck() ? filemobile : file;
            const key = element.attr('id');
            const animation = lottie.loadAnimation({
                container: element[0],
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path
            })
            animations[key] = {
                element: animation,
                inPlay: false,
            }
            animation.addEventListener('complete', function () {
                setTimeout(() => {
                    animation.goToAndPlay(0);
                }, 60000);
            })
        }
    }
    function validateIfAnimation() {
        const list = jQuery('.block-u-lottie__element');
        const top = window.scrollY;
        for (const iterator of list) {
            const element = jQuery(iterator);
            const key = element.attr('id');
            const animation = animations[key];
            if (animation.inPlay) {
                continue;
            }
            const rect = element.offset();
            const height = element.height();
            let start = rect.top - height / 2;
            const end = rect.top + height;
            if (mobileAndTabletCheck()) {
                start -= 100;
            }
            if (start <= top && end >= top) {
                animation.inPlay = true;
                animation.element.play();
            }
        }
    }
    init();
}
new BlockULottie();